import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import VueRouter from "vue-router";
import "./scaffoldings";
import Notification from "src/helpers/Notification";
import {setBaseUrl} from "dev/packages/MyAxios";
import AuthCheck from "dev/packages/AuthCheck";
import VeeValidate from "vee-validate";
import "dev/helpers/RoleManager";
import i18n from "dev/lang";
import VueMask from "v-mask";
Vue.use(VueMask);
Vue.use(VeeValidate);
function $t(key) {
  return key;
}

store.watch((state) => state.ConfigModule.request.baseUrl, (path) => {
  setBaseUrl(path);
});

Vue.use(Notification);
Vue.use(AuthCheck);
Vue.use(VueRouter);
Vue.config.productionTip = false;
new Vue({
  vuetify,
  $_veeValidate: {
    validator: "new",
  },
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
